// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'general v4.0.0',
    items: [
      {
        title: "Users",
        path: "/users",
        roles: ["System Admin", "Admin"]
      },
      {
        title: "Jobs",
        path: "/jobs"
      },
      {
        title:"Businesses",
        path: "/businesses",
        roles: ["System Admin"]
      }
    ],
  },

];

export default navConfig;
